import { Injectable, signal } from '@angular/core';

/**
 * Global trigger for the "not wired up yet" dialog shown on buttons that don't have real
 * functionality behind them — surfaces a permission-request message instead of doing nothing.
 */
@Injectable({ providedIn: 'root' })
export class PermissionRequestService {
    readonly visible = signal(false);
    readonly actionLabel = signal('');

    request(actionLabel: string): void {
        this.actionLabel.set(actionLabel);
        this.visible.set(true);
    }

    close(): void {
        this.visible.set(false);
    }
}
